import React, { useCallback, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DashboardPageHeader from "components/common/DashboardPageHeader";
import TrainingDeckViewer from "components/training/TrainingDeckViewer";
import { useAuth } from "hooks/useAuth";
import { DECK_BY_ROLE } from "services/trainingDeckService";
import { markRoleOrientationComplete } from "services/fde/roleOnboardingService";

const FdeCOnboardingPage = () => {
  const navigate = useNavigate();
  const { userData } = useAuth();
  const hierarchyPath = useMemo(
    () => ({
      institutionId: userData?.institutionId || userData?.organizationId,
      departmentId: userData?.departmentId || null,
    }),
    [userData?.departmentId, userData?.institutionId, userData?.organizationId],
  );

  const handleComplete = useCallback(async () => {
    await markRoleOrientationComplete({ fdeC: true });
    navigate("/dashboard/sessions");
  }, [navigate]);

  return (
    <Box sx={{ p: 3, maxWidth: 900, mx: "auto" }}>
      <DashboardPageHeader
        title="Clinical Annotator orientation"
        subtitle="Confirm your TCI assignment and complete orientation before annotating sessions."
      />
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Review the deck below, then open Sessions to begin annotating conversations for your assigned TCI.
      </Typography>
      <TrainingDeckViewer
        deckId={DECK_BY_ROLE["fde-c"]}
        userHierarchyPath={hierarchyPath}
        onComplete={handleComplete}
      />
    </Box>
  );
};

export default FdeCOnboardingPage;
